// extracted by mini-css-extract-plugin
var _1 = "Comment_author__dyl9z";
var _2 = "Comment_button__5sFXw";
var _3 = "Comment_buttonIcon__5eLG8";
var _4 = "Comment_buttons__HrnxK";
var _5 = "Comment_content__GrTYu";
var _6 = "Comment_date__2DKhk";
var _7 = "Comment_edited__gIABI";
var _8 = "Comment_popupWrapper__uQQR4";
var _9 = "Comment_preview__lUHby";
var _a = "Comment_title__QqHUr";
var _b = "Comment_user__Fdbs1";
export { _1 as "author", _2 as "button", _3 as "buttonIcon", _4 as "buttons", _5 as "content", _6 as "date", _7 as "edited", _8 as "popupWrapper", _9 as "preview", _a as "title", _b as "user" }
